import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import MobileStaffSelector from "./mobile-staff-selector.vue";
import { StaffSelectorControl } from "../controls/staff-selector-control";
let FormStaffSelector = class FormStaffSelector extends StaffSelectorControl {
    onChange(value) {
        this.ctrl.value = value && value.length > 0 ? value : null;
    }
    // 是否为外部用户
    get isExternal() {
        if (window.isExternal) {
            return true;
        }
        return false;
    }
    mounted() {
        // 选人控件需要从根节点开始显示
        this.staffSelectorOpts.isDisplayRoot = true;
    }
};
FormStaffSelector = tslib_1.__decorate([
    Component({
        name: "form-staff-selector",
        components: {
            MobileStaffSelector
        }
    })
], FormStaffSelector);
export default FormStaffSelector;
